//#region src/_internal/deprecations.ts
const logDeprecationWarning = (message) => {
	console.warn(`⚠️ [uploadthing][deprecated] ${message}`);
};

//#endregion
export { logDeprecationWarning };
//# sourceMappingURL=deprecations-pLmw6Ytd.js.map